import SensorResource from '@/api/resources/sensor'
import { SensorType } from '@/interfaces/enums'
import type { ISensor } from '@/interfaces/entities/sensor'
import type { IRegisterChartSensorData } from '@/utils/components/register-chart'

export interface IFetchSensorReadingsByTypeParams {
  sensor: ISensor
  dateRange: string
  resolution: string
  aggregation?: string
}

/** Busca leituras por tipo de sensor sem acoplar a store/lista de blocos. */
export async function fetchSensorReadingsByType(
  params: IFetchSensorReadingsByTypeParams,
): Promise<IRegisterChartSensorData | null> {
  const { sensor, dateRange, resolution, aggregation = 'mean' } = params
  const payload = {
    sensorId: sensor.id,
    dateRange,
    resolution,
    aggregation,
  }

  let response: {
    sensor?: ISensor
    start_date?: string
    end_date?: string
    readings?: Record<string, Array<{ t?: string | number; v?: number }>>
  } | null = null

  if (sensor.sensor_type === SensorType.ELECTRICITY) {
    response = await SensorResource.getEnergySensorReadings(payload)
  } else if (sensor.sensor_type === SensorType.TEMPERATURE) {
    response = await SensorResource.getTemperatureSensorReadings(payload)
  } else if (sensor.sensor_type === SensorType.DOOR_OPEN) {
    response = await SensorResource.getOpenSensorReadings(payload)
  } else {
    return null
  }

  if (!response?.sensor || !response.readings) {
    return null
  }

  return {
    sensor: response.sensor,
    start_date: response.start_date ?? '',
    end_date: response.end_date ?? '',
    readings: response.readings,
  }
}
